<scitis-app-global-page-header [pageTitle]="'Organization design'">

  <ng-template #filterElement>
    <button (click)="onResetBrandingDetails()"
            title="{{'reset design to Parent-Organization' | translate}}"
            [disabled]="(!isAdminRole && !isSuperAdminRole)"
            class="btn btn-outline-primary">
      <span class="fa-solid fa-rotate-left"></span>
      <span translate>Reset</span>
    </button>
  </ng-template>

  <ng-template #filterElement>
    <button class="btn btn-outline-primary" (click)="previewChange()">
      <span class="fa-solid fa-eye"></span>
      <span translate>Preview</span>
    </button>
  </ng-template>

</scitis-app-global-page-header>


<div class="row">
  <!--FIRST COLUMN -- COLORS-->
  <div class="col-12">
    <div class="card mb-3">
      <div class="card-header">
        <span class="fa-solid fa-paintbrush mr-2"></span>
        <span translate>Colors</span>
      </div>
      <div class="card-body">
        <div class="branding-color-wrapper">
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.primary"
                 (click)="primaryColorToggle=!primaryColorToggle"></div>
            <input id="primaryColor"
                   readonly
                   (click)="primaryColorToggle=!primaryColorToggle"

                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('primary', $event)"
                   [(colorPicker)]="branding.colors.primary"
                   [(cpToggle)]="primaryColorToggle"
                   [value]="branding.colors.primary"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="primaryColor">
                <span translate>Primary</span>
              </label>
              <p translate>This is the main color of the portal, used for the titlebar, buttons and other elements.</p>
            </div>
          </div>
          <!-- Placeholder secondary color start -->
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': !branding.secondaryColorEnabled || brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.secondary || branding.colors.primary"
                 (click)="secondaryColorToggle=!secondaryColorToggle"></div>
            <input id="secondaryColor"
                   readonly
                   (click)="secondaryColorToggle=!secondaryColorToggle"
                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('secondary', $event)"
                   [(colorPicker)]="branding.colors.secondary"
                   [(cpToggle)]="secondaryColorToggle"
                   [value]="branding.colors.secondary || branding.colors.primary"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="secondaryColor">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitch1"
                         [checked]="branding.secondaryColorEnabled" (change)="applySecondaryColor($event)">
                  <label class="custom-control-label" for="customSwitch1">Secondary (optional)</label>
                </div>
              </label>
              <p translate>Will be used for elements on light background. Set if primary color is too light.</p>
            </div>
          </div>
          <!-- Placeholder secondary color end -->
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.highlight"
                 (click)="highlightColorToggle=!highlightColorToggle"></div>
            <input id="highlightColor"
                   readonly
                   (click)="highlightColorToggle=!highlightColorToggle"
                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('highlight', $event)"
                   [(cpToggle)]="highlightColorToggle"
                   [(colorPicker)]="branding.colors.highlight"
                   [value]="branding.colors.highlight"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="highlightColor">
                <span translate>Highlight</span>
              </label>
              <p translate>Will be used for darker backgrounds like the sidemenu, to guarantee good readability.</p>
            </div>
          </div>
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.success"
                 (click)="successColorToggle=!successColorToggle"></div>
            <input id="successColor"
                   readonly
                   (click)="successColorToggle=!successColorToggle"
                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('success', $event)"
                   [(colorPicker)]="branding.colors.success"
                   [(cpToggle)]="successColorToggle"
                   [value]="branding.colors.success"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="successColor">
                <span translate>Success</span>
              </label>
              <p translate>Success states in forms, toasts and other status related elements.</p>
            </div>
          </div>
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.warning"
                 (click)="warningColorToggle=!warningColorToggle"></div>
            <input id="warningColor"
                   readonly
                   (click)="warningColorToggle=!warningColorToggle"
                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('warning', $event)"
                   [(colorPicker)]="branding.colors.warning"
                   [(cpToggle)]="warningColorToggle"
                   [value]="branding.colors.warning"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="warningColor">
                <span translate>Warning</span>
              </label>
              <p translate>Warning states in forms, toasts and other status related elements.</p>
            </div>
          </div>
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.info"
                 (click)="infoColorToggle=!infoColorToggle"></div>
            <input id="infoColor"
                   readonly
                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('info', $event)"
                   [(colorPicker)]="branding.colors.info"
                   [(cpToggle)]="infoColorToggle"
                   [value]="branding.colors.info"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="infoColor">
                <span translate>Info</span>
              </label>
              <p translate>Info states in forms, toasts and other status related elements.</p>
            </div>

          </div>
          <div class="branding-color" [ngClass]="{ 'branding-color-inactive': brandingIsLoading }">
            <div class="branding-color-preview" [style.background]="branding.colors.danger"
                 (click)="dangerColorToggle=!dangerColorToggle"></div>
            <input id="dangerColor"
                   readonly
                   (click)="dangerColorToggle=!dangerColorToggle"
                   class="branding-color-input"
                   (colorPickerSelect)="onCloseColorPicker('danger', $event)"
                   [(colorPicker)]="branding.colors.danger"
                   [(cpToggle)]="dangerColorToggle"
                   [value]="branding.colors.danger"
                   [cpOutputFormat]="'hex'"
                   [cpAlphaChannel]="'disabled'"
                   [cpOKButton]="true"
                   [cpOKButtonClass]="'btn btn-primary'"
                   [cpCancelButtonClass]="'btn btn-outline-primary'"
                   [cpCancelButton]="true"/>
            <div class="branding-text">
              <label for="dangerColor">
                <span translate>Danger</span>
              </label>
              <p translate>Danger or Error states in forms, toasts and other status related elements.</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="card">
      <div class="card-header">Logos</div>
      <div class="card-body">

        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <scitis-admin-organization-branding-image
                [logoDetails]="logoSettings"
                [isSuperAdminRole]="isAdminRole"
                [isAdminRole]="isSuperAdminRole"
                [background]="imageBackgroundColor"
                [image]="branding.images.logo"
                [parentImage]="parentBranding.images.logo"
                [brandingIsLoading]="brandingIsLoading"
                (imageChangedEvent)="onImageChanged($event, imageSetting.LOGO.name)">

            </scitis-admin-organization-branding-image>
          </li>
          <li class="list-group-item">
            <scitis-admin-organization-branding-image
                [logoDetails]="logoMobileSettings"
                [isSuperAdminRole]="isAdminRole"
                [isAdminRole]="isSuperAdminRole"
                [background]="imageBackgroundColor"
                [image]="branding.images.logoMobile"
                [parentImage]="parentBranding.images.logoMobile"
                [brandingIsLoading]="brandingIsLoading"
                (imageChangedEvent)="onImageChanged($event, imageSetting.LOGO_MOBILE.name)">

            </scitis-admin-organization-branding-image>
          </li>
          <li class="list-group-item">
            <scitis-admin-organization-branding-image
                [logoDetails]="favIconSettings"
                [isSuperAdminRole]="isAdminRole"
                [isAdminRole]="isSuperAdminRole"
                [background]="imageBackgroundColor"
                [image]="branding.images.favIcon"
                [parentImage]="parentBranding.images.favIcon"
                [brandingIsLoading]="brandingIsLoading"
                (imageChangedEvent)="onImageChanged($event, imageSetting.FAV_ICON.name)">
            </scitis-admin-organization-branding-image>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
